import { SidebarProvider } from "../shadcn/components/ui/Sidebar";
import { Topbar } from "../Component/dashboard/Topbar";
import { DashboardSidebar as Sidebar } from "../Component/dashboard/Sidebar";
import { Outlet, useLocation, useParams } from "react-router-dom";
import { Servicesform } from "../Component/dashboard/services/Servicesform";
import { useEffect, useState } from "react";
import { AccountingPage } from "../Component/dashboard/Accounting/AccountingPage";
import { HelpAndSupport } from "../Component/dashboard/Help&Support/HelpSupport";
import Message, {
  CorporateMessages,
} from "../Component/dashboard/messages/Messages";
import { MyProfile } from "../Component/dashboard/Myprofile/MyProfile";
import { Applications } from "../Component/dashboard/Applications/Applications";
import PropertyForm from "../Component/dashboard/Propertyform/Propertyform";
import ServiceInfoform from "../Component/serviceProvider dashboard/serviceinfo/Serviceinfo";
import Trasportationform from "../Component/dashboard/Transportation/Trasportationform";
import { RentalApplicationForm } from "../Component/dashboard/services/RentalApplication/RentalForm";
import { RentalApplication } from "../Component/dashboard/services/RentalApplication/Rentalafterapprove";
import { LeaseForm } from "../Component/dashboard/services/lease/LeaseForm";
import PostPropertyForm from "../Component/dashboard/postservice/Postservice";
import Transport from "../Component/dashboard/Transportation/Trasportationform";
import ServiceInformationForm from "../Component/dashboard/Serviceinformation/Serviceinformation.jsx/Serviceinformation";
import FilledLeaseForm from "../Component/dashboard/Applications/Filledleaseform";
import FilledRentalApplication from "../Component/dashboard/Applications/Filledrentalform";
import Notification from "../Component/Notification";

export function Dashboard() {
  const { section, id } = useParams();
  const [isOpen, setIsOpen] = useState(window.innerWidth <= 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsOpen(window.innerWidth >= 1024);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSidebar = () => {
    setIsOpen((prev) => !prev);
  };

  const location = useLocation();
  const pathSegments = location.pathname.split("/").filter(Boolean);
  const mainSection = pathSegments[1] || ""; // ["", "dashboard", "section"]
  const itemId = pathSegments[2] || ""; // ID if exists

  return (
    <SidebarProvider preventAutoToggle={true} className="">
      <div className="flex min-h-screen w-full">
        <Sidebar isOpen={isOpen} toggleSidebar={toggleSidebar} />
        <div className={`flex-1 flex flex-col`}>
          <Topbar section={section} mainSection={mainSection} />

          <main className="flex-1 overflow-auto p-4">
            {section === "Notification" && <Notification />}
            {section === "My profile" && <MyProfile />}
            {section === "services" && <Servicesform />}
            {section === "application" && <Applications />}
            {section === "accounting" && <AccountingPage />}
            {section === "messages" && <CorporateMessages />}
            {section === "Help & Support" && <HelpAndSupport />}

            {mainSection === "propertyForm" && <PostPropertyForm id={itemId} />}
            {mainSection === "ServiceInformationForm" && (
              <ServiceInformationForm id={itemId} />
            )}
            {mainSection === "Transportationform" && <Transport id={itemId} />}

            {section === "rental" && <RentalApplicationForm />}
            {section === "rentalapproved" && <RentalApplication />}
            {section === "lease" && <LeaseForm />}
            {section === "filledlease" && <FilledLeaseForm />}
            {section === "filledrental" && <FilledRentalApplication />}
            {/* tempperory routes */}
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
}
